/**
 * @fileoverview Entity Picker type tabs presentation component
 */

goog.declareModuleId('yext.ui.components.entitypicker.PickerTabs');
import {hasManaUITheme} from '/ui/design/hasManaUITheme';

import * as styles from '/ui/components/entitypicker/tabs/tabs.module.scss';

export function PickerTabs(props) {
  return (
    <div className={hasManaUITheme() ? styles.uepTypeTabs : 'uep-type-tabs'}>
      {props.children}
    </div>
  );
}
